export enum enumPublished {
  YES = 'YES',
  NO = 'NO',
}
